'use strict';
var angular = require('angular');

var actiontWebServiceCtrl = ['$uibModal', 'toast', '$translate', "BuilderDataService", function ($uibModal, toast, $translate,BuilderDataService) {
    var _this = this;

    
    _this.webservice.connection.data = _this.webservice.connection.data ?? "return instance;";
    
    _this.webservice.connection.request_type = _this.webservice.connection.request_type ?? "json";

    _this.webservice.connection.auth = _this.webservice.connection.auth || { type: "" };

    this.form = BuilderDataService.getForm();
    _this.simpleListAvailable = this.form.pages.reduce((lst, page) => {
        lst = lst.concat(BuilderDataService.getListOfElements(page.fields, "simplelist", "include"));
        return lst;
    }, []); 

    //---------------------------------------
    // Convert obj to array
    if (!this.webservice.connection.queryParams) { 
        this.webservice.connection.queryParams = []; 
        // console.log('this.webservice.connection.queryParams = []; ')
    } else if (!angular.isArray(this.webservice.connection.queryParams)) {
        let obj = this.webservice.connection.queryParams;
        this.webservice.connection.queryParams = Object.keys(obj).map(function(key) {
            return { key: key, value: obj[key] };
        });
        // console.log('this.webservice.connection.queryParams converted', this.webservice.connection.queryParams);
    }

    if (!this.webservice.connection.headers) { 
        this.webservice.connection.headers = []; 
        // console.log('this.webservice.connection.headers = []; ')
    } else if (!angular.isArray(this.webservice.connection.headers)) {
        let obj = this.webservice.connection.headers;
        this.webservice.connection.headers = Object.keys(obj).map(function(key) {
            return { key: key, value: obj[key] };
        });
        // console.log('this.webservice.connection.headers converted', this.webservice.connection.headers);
    }

    if (!this.webservice.connection.responseParams) {
        this.webservice.connection.responseParams = [];
    } else if (!angular.isArray(this.webservice.connection.responseParams)) {
        let obj = this.webservice.connection.responseParams;
        this.webservice.connection.responseParams = Object.keys(obj);
    } else {
        this.webservice.connection.responseParams = this.webservice.connection.responseParams.map(function (item) {
            if (typeof item === 'string') return item;
            return item.key || item.id || item.name || '';
        }).filter(Boolean);
    }
    
    this.addNewEntry = function (where) {
        // console.log('addNewEntry', where)
        where.push({ key: '', value: '' });
    };
    
    this.removeEntry = function (index, where) {
        where.splice(index, 1);
    };

    //---------------------------------------

    _this.loadEditorHTML = function () {
        const _options = {
            // editor options
            selectionStyle: "line", // "line"|"text"
            highlightActiveLine: true, // boolean
            highlightSelectedWord: true, // boolean
            readOnly: false, // boolean: true if read only
            cursorStyle: "ace", // "ace"|"slim"|"smooth"|"wide"
            mergeUndoDeltas: true, // false|true|"always"
            behavioursEnabled: true, // boolean: true if enable custom behaviours
            wrapBehavioursEnabled: true, // boolean
            autoScrollEditorIntoView: undefined, // boolean: this is needed if editor is inside scrollable page
            keyboardHandler: null, // function: handle custom keyboard events

            // renderer options
            animatedScroll: false, // boolean: true if scroll should be animated
            displayIndentGuides: false, // boolean: true if the indent should be shown. See 'showInvisibles'
            showInvisibles: false, // boolean -> displayIndentGuides: true if show the invisible tabs/spaces in indents
            showPrintMargin: true, // boolean: true if show the vertical print margin
            printMarginColumn: 80, // number: number of columns for vertical print margin
            printMargin: undefined, // boolean | number: showPrintMargin | printMarginColumn
            showGutter: true, // boolean: true if show line gutter
            fadeFoldWidgets: false, // boolean: true if the fold lines should be faded
            showFoldWidgets: true, // boolean: true if the fold lines should be shown ?
            showLineNumbers: true,
            highlightGutterLine: false, // boolean: true if the gutter line should be highlighted
            hScrollBarAlwaysVisible: false, // boolean: true if the horizontal scroll bar should be shown regardless
            vScrollBarAlwaysVisible: false, // boolean: true if the vertical scroll bar should be shown regardless
            fontSize: 14, // number | string: set the font size to this many pixels
            fontFamily: undefined, // string: set the font-family css value
            maxLines: undefined, // number: set the maximum lines possible. This will make the editor height changes
            minLines: undefined, // number: set the minimum lines possible. This will make the editor height changes
            maxPixelHeight: 0, // number -> maxLines: set the maximum height in pixel, when 'maxLines' is defined.
            scrollPastEnd: 0, // number -> !maxLines: if positive, user can scroll pass the last line and go n * editorHeight more distance
            fixedWidthGutter: false, // boolean: true if the gutter should be fixed width
            theme: "ace/theme/dracula", // theme string from ace/theme or custom?

            // mouseHandler options
            scrollSpeed: 2, // number: the scroll speed index
            dragDelay: 0, // number: the drag delay before drag starts. it's 150ms for mac by default
            dragEnabled: true, // boolean: enable dragging
            focusTimeout: 0, // number: the focus delay before focus starts.
            tooltipFollowsMouse: true, // boolean: true if the gutter tooltip should follow mouse

            // session options
            firstLineNumber: 1, // number: the line number in first line
            overwrite: false, // boolean
            newLineMode: "auto", // "auto" | "unix" | "windows"
            useWorker: true, // boolean: true if use web worker for loading scripts
            useSoftTabs: true, // boolean: true if we want to use spaces than tabs
            tabSize: 4, // number
            wrap: false, // boolean | string | number: true/'free' means wrap instead of horizontal scroll, false/'off' means horizontal scroll instead of wrap, and number means number of column before wrap. -1 means wrap at print margin
            indentedSoftWrap: true, // boolean
            foldStyle: "markbegin", // enum: 'manual'/'markbegin'/'markbeginend'.
            mode: "ace/mode/javascript", // string: path to language mode
        };
        _this.editor = ace.edit("payloadEditor" + _this.index);
        _this.editor.setOptions(_options);
        _this.editor.session.on("change", function (delta) {
            _this.webservice.connection.data = _this.editor.session.getValue();
        });

        _this.editorResponse = ace.edit("responseEditor" + _this.index);
        _this.editorResponse.setOptions(_options);
        _this.editorResponse.session.on("change", function (delta) {
            _this.webservice.connection.response = _this.editorResponse.session.getValue();
        });
        
        _this.formatCode();
    };

    _this.formatCode = () => {
        _this.editor.session.setValue(
            js_beautify(_this.editor.session.getValue())
        );

        _this.editorResponse.session.setValue(
            js_beautify(_this.editorResponse.session.getValue())
        );
    };

    this.showInstanceReference = function () {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-builder/formConfig/actionWebServiceInstance.html',
            controller: [
                "$uibModalInstance",
                "BuilderDataService",
                function ($uibModalInstance, BuilderDataService) {
                    this.form = BuilderDataService.getForm();
                    this.valueElements = this.form.pages.reduce((lst, page) => {
                        lst = lst.concat(BuilderDataService.getListOfElements(page.fields, _this.excludeTypes));
                        return lst;
                    }, []); 
                    this.close = function () {
                        $uibModalInstance.close();
                    };
                    this.clic=(attr)=>{                        
                        $uibModalInstance.close("instance.".concat(attr));
                    }
                },
            ],

            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
        }).result.then(function (code) {
            // if(code)
            //     _this.editor.insert(code);
            if (code) {
                var currentCursorPosition = _this.editor.getCursorPosition(); // Obtén la posición actual del cursor
                _this.editor.insert(code); // Inserta el código
                var codeLines = code.split('\n');
                var newPosition = {
                    row: currentCursorPosition.row + codeLines.length - 1, // Calcula la nueva fila del cursor
                    column: codeLines.pop().length // Calcula la nueva columna del cursor
                };
                _this.editor.moveCursorToPosition(newPosition); // Mueve el cursor a la posición deseada
                _this.editor.focus(); // Pone el foco en el editor
            }
        });;
    };

    angular.element(document).ready(_this.loadEditorHTML);
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            webservice: '=',
            webValidation: '=',
            element: '=',
            index: '=',
        },
        controller: actiontWebServiceCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/formConfig/actionWebServiceDirective.html'
    };
};